exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table .btn-primary {\r\n    color: #fff;\r\n}\r\n\r\n.grand-total-box {\r\n    background-color: #fff;\r\n    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.05);\r\n    border-radius: 4px;\r\n    margin-bottom: 80px;\r\n}\r\n\r\n    .grand-total-box .sales-tax2 {\r\n        padding: 16px 25px;\r\n        display: flex;\r\n        justify-content: space-between;\r\n    }\r\n\r\n    .grand-total-box .grand-total2 {\r\n        font-size: 1.25rem;\r\n        padding: 16px 5px;\r\n        display: flex;\r\n        justify-content: space-between;\r\n    }\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./ClientApp/components/quotes/View.css
// module id = 613
// module chunks = 0